var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { View } from 'react-native';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { SwitchView } from '../Common/SwitchView';
import { AnimatedView } from '../Common/AnimatedView';
let ChoiceItemSwitchView = class ChoiceItemSwitchView extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = () => {
            if (this.props.disabled) {
                return;
            }
            const updatedValue = this.props.value === 0
                ? 1
                : 0;
            typeof this.props.onChange === 'function' && this.props.onChange(this.props.id, updatedValue);
        };
    }
    render() {
        var _a, _b, _c, _d;
        return (_jsxs(AnimatedView, { style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, children: [_jsx(SwitchView, { testID: `choice-item-${this.props.testID || this.props.title || ''}`, value: !!this.props.value, onChange: this.handleChange }), _jsxs(View, { style: (_b = this.props.style) === null || _b === void 0 ? void 0 : _b.end, children: [_jsx(AnimatedTextView, { textStyle: (_c = this.props.style) === null || _c === void 0 ? void 0 : _c.title, light: this.props.light, children: this.props.title }), !!this.props.description && (_jsx(AnimatedTextView, { textStyle: (_d = this.props.style) === null || _d === void 0 ? void 0 : _d.description, light: this.props.light, children: this.props.description }))] })] }));
    }
};
ChoiceItemSwitchView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.switch,
        style(theme, mediaQuery, window, props) {
            var _a, _b, _c;
            return {
                container: {
                    opacity: props.disabled ? 0.4 : 1,
                    flexDirection: ((_a = props.customize) === null || _a === void 0 ? void 0 : _a.dir) === 'reverse'
                        ? 'row-reverse'
                        : 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                },
                end: {
                    flex: 1,
                    paddingEnd: ((_b = props.customize) === null || _b === void 0 ? void 0 : _b.dir) === 'reverse'
                        ? 15
                        : 0,
                    paddingStart: ((_c = props.customize) === null || _c === void 0 ? void 0 : _c.dir) === 'reverse'
                        ? 0
                        : 15
                },
                start: {
                    marginVertical: 2
                },
                title: {
                    fontSize: 16,
                    lineHeight: 20
                },
                description: {
                    fontSize: 12,
                    lineHeight: 16
                }
            };
        }
    })
], ChoiceItemSwitchView);
export { ChoiceItemSwitchView };
